// pages/subscribe.tsx
import { useEffect } from "react";
import axios from "axios";
import {
  useLocale,
} from '@lilbit/shared';

export default function SubscribePage() {
   const urlPrefix = useLocale().urlPrefix;
 const translations = {
    redirectingToSubscription: {
      no: 'Viderekobler til abonnementsbetaling …',
      en: 'Redirecting to subscription checkout…',
      se: 'Redirecting to subscription checkout…',
      da: 'Redirecting to subscription checkout…',
      fi: 'Redirecting to subscription checkout…',
      de: 'Redirecting to subscription checkout…',
      fr: 'Redirecting to subscription checkout…',
      nl: 'Redirecting to subscription checkout…',
      es: 'Redirecting to subscription checkout…',
    },
  
  }
  useEffect(() => {
    const runSubscription = async () => {
      try {
        // Grab query params from URL (passed from Shopify)
        const urlParams = new URLSearchParams(window.location.search);
        const product_id = urlParams.get("product_id");
        const variant_id = urlParams.get("variant_id");
        const email = urlParams.get("email"); 
        const subbed_to_newsletter = urlParams.get("newsletter_subscribed");
        
        // Call your API route
        const response = await axios.post("/api/stripe/create-sub-shopify",null, {
          params: {
            product_id,
            variant_id,
            email,
            subbed_to_newsletter
          },
        });
        
        // Redirect to Stripe Checkout
       window.location.href = response.data.url;
      } catch (error) {
        console.error("Subscription error:", error);
        alert("Failed to start subscription.");
      }
    };

    runSubscription();
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>{translations.redirectingToSubscription[urlPrefix]}</h1>
    </div>
  );
}